var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4598 5.1065L8.56554 12.0008L15.4598 18.8951C15.7527 19.1879 15.7527 19.6628 15.4598 19.9557C15.1669 20.2486 14.6921 20.2486 14.3992 19.9557L6.97455 12.5311C6.8339 12.3904 6.75488 12.1997 6.75488 12.0008C6.75488 11.8018 6.8339 11.6111 6.97455 11.4704L14.3992 4.04584C14.4358 4.00923 14.4752 3.97719 14.5168 3.94973C14.8079 3.75752 15.2035 3.78956 15.4598 4.04584C15.7527 4.33873 15.7527 4.81361 15.4598 5.1065Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeft);
export default __webpack_public_path__ + "static/media/icon_arrow_left.57212f28db09b7ea504e0f0404fda6b9.svg";
export { ForwardRef as ReactComponent };